import React from "react";
import { RouteHttpVerb } from "@devowl-wp/utils";
import { Spin } from "antd";
import { useCallback, useEffect, useState, forwardRef } from "react";
import { hooks, mediaUtils } from "wp";
import { request as utilsRequest } from "../util";
let addedFilter = false;

/**
 * Some page builders (e.g. Divi) move the `mediaUtils` to the footer and/or after Real Media Library scripts.
 */
function addMediaUploadFilterLazily() {
  const {
    addFilter
  } = hooks;
  const {
    MediaUpload
  } = mediaUtils;
  if (!addedFilter) {
    addedFilter = true;
    const replaceMediaUpload = () => MediaUpload;
    addFilter("editor.MediaUpload", "core/edit-post/components/media-upload/replace-media-upload", replaceMediaUpload);
  }
  return MediaUpload;
}
function useMediaAttachment(id) {
  const [fetching, setFetching] = useState(false);
  const [data, setData] = useState();
  const [error, setError] = useState();
  const fetch = useCallback(async id => {
    setFetching(true);
    try {
      const result = await utilsRequest({
        location: {
          path: `/media/:id`,
          method: RouteHttpVerb.GET,
          namespace: "wp/v2"
        },
        params: {
          id
        }
      });
      setData(result);
      setError(undefined);
    } catch (e) {
      setData(undefined);
      setError(e);
    } finally {
      setFetching(false);
    }
  }, []);
  useEffect(() => {
    if (id) {
      fetch(id);
    } else {
      setData(undefined);
      setError(undefined);
    }
  }, [id]);
  return {
    fetching,
    data,
    fetch,
    error
  };
}
const MediaLibrarySelector = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    attachmentId,
    title,
    allowedTypes,
    render,
    onChange
  } = _ref;
  const useAttachmentId = attachmentId || undefined;
  const {
    data,
    error,
    fetching
  } = useMediaAttachment(useAttachmentId);
  const url = data === null || data === void 0 ? void 0 : data.source_url;
  useEffect(() => {
    var _error$responseJSON;
    if ((error === null || error === void 0 ? void 0 : (_error$responseJSON = error.responseJSON) === null || _error$responseJSON === void 0 ? void 0 : _error$responseJSON.code) === "rest_post_invalid_id") {
      onChange(undefined, undefined);
    }
  }, [error]);
  const MediaUpload = addMediaUploadFilterLazily();
  return /*#__PURE__*/React.createElement(Spin, {
    spinning: fetching
  }, /*#__PURE__*/React.createElement(MediaUpload, {
    ref: ref,
    onSelect: media => {
      onChange === null || onChange === void 0 ? void 0 : onChange(media === null || media === void 0 ? void 0 : media.id, media);
    },
    title: title,
    allowedTypes: allowedTypes,
    value: useAttachmentId,
    render: _ref2 => {
      let {
        open
      } = _ref2;
      return render({
        open,
        reset: () => onChange(undefined, undefined),
        attachmentId: useAttachmentId,
        url
      });
    }
  }));
});
export { MediaLibrarySelector };